import { Component, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { PrimeNGModules } from '../../../../shared/alpha-shared.module';

@Component({
    selector: 'app-filter-save',
    standalone: true,
    templateUrl: './filter-save.component.html',
    styleUrl: './filter-save.component.scss',
    imports: [...PrimeNGModules, TranslatePipe],
})
export class FilterSaveComponent {
    private dialogRef = inject(DynamicDialogRef);
    private config = inject(DynamicDialogConfig);

    value: string = '';
    presentNames: string[] = [];
    isDuplicate!: boolean;
    constructor() {
        this.presentNames = this.config.data.presentNames;
        if (this.config.data.currentSelectedFilter) this.value = this.config.data.currentSelectedFilter;
    }
    onButtonClick(data = '') {
        this.dialogRef.close(data);
    }

    valueChange(event: any) {
        // Check if the event value is in the presentNames array and is different from the current selected filter
        this.isDuplicate = this.presentNames.includes(event) && event !== this.config.data.currentSelectedFilter;
    }
}
